import { NgModule } from '@angular/core';
import { ChartsDirective } from './charts.directive';
import { ChartsService, HIGHCHARTS_MODULES } from './charts.service';

@NgModule({
  exports: [ ChartsDirective ],
  declarations: [ ChartsDirective ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useValue: [] },
    ChartsService
  ]
})
export class ChartsModule {
  constructor(private readonly cs: ChartsService) {
    this.cs.initModules();
  }
}
